import extendNode from '../extendNode.mjs'
import useAbstractNode from '../_ABSTRACT/useAbstractNode.jsx'
import meta from './metaBdlogic_1.mjs'
import FormChoose from './FormChooseBdlogic_1.jsx'
import TableChoose from './TableChooseBdlogic_1.jsx'
import api from './apiBdlogic_1.mjs'

export default () => {
    const AbstractNode = useAbstractNode()

    return extendNode(AbstractNode, {
        ...meta,
        api,
        FormChoose,
        TableChoose,
    })
}
